import type { DiscoveredRouteModule } from '@/router/generator/types';

const AdminIndexView = () => import('@/views/admin/IndexView.vue');
export const NAME_ADMIN_INDEX = 'AdminIndex';
export const PATH_ADMIN_INDEX = '';

export const route: DiscoveredRouteModule = {
  id: 'admin.index',
  scope: 'admin',
  name: NAME_ADMIN_INDEX,
  path: PATH_ADMIN_INDEX,
  component: AdminIndexView,
  meta: { requiresAdmin: true },
  order: 0 // Ensure AdminIndex is sorted first
};


